export default "__VITE_ASSET__Cel4Xe3___"